<template>
  <!-- Main Sidebar Container -->
  <aside :class="cssClassMainSideBar">
    <!-- Brand Logo -->
    <div v-if="opcaoMenuGestaoConta" class="elevation-0 divLogoDegrade">
      <router-link to="/contratos">
        <img src="@/assets/img/logo-mirt-horizontal.svg" class="brand-image mx-auto d-block" />
      </router-link>
    </div>
    <div v-if="opcaoMenuSistemaJuridico" class="elevation-0 divLogoDegrade">
      <router-link to="/inicio">
        <img :src="obterLogo" class="brand-image mx-auto d-block" />
      </router-link>
    </div>
    <span class="brand-text font-weight-light">&nbsp;</span>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user (optional) -->
      <div v-if="opcaoMenuGestaoConta" class="mt-1 brand-text text-center nomeFantasiaEscritorio">{{ nomeEmpresa }}</div>
      <div v-if="opcaoMenuGestaoConta" class="mt-1 pb-2 mb-2 brand-text text-center cpfCnpjEscritorio">{{ obterCpfCnpj() }}</div>
      <!-- Sidebar Menu -->
      <nav>
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
              with font-awesome or any other icon font library -->
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <router-link class="nav-link" to="/inicio">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Início
              </p>
            </router-link>
          </li>
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <a href="#" class="nav-link" v-on:click.stop.prevent="acessarJudiceOffice">
              <i class="nav-icon fas fa-balance-scale"></i>
              <p>
                Jurídico
              </p>
              <b-spinner v-if="flags.autenticacao.office" class="ml-2" small variant="danger"></b-spinner>
            </a>
          </li>
          <li v-if="temAcessoAoFaturamento && opcaoMenuSistemaJuridico" class="nav-item">
            <a href="#" class="nav-link" v-on:click.stop.prevent="acessarFaturamento">
              <i class="nav-icon fas fa-cash-register"></i>
              <p>
                Financeiro
              </p>
              <b-spinner v-if="flags.autenticacao.faturamento" class="ml-2" small variant="danger"></b-spinner>
            </a>
          </li>
          <li v-if="temAcessoAoFinanceiro && opcaoMenuSistemaJuridico" class="nav-item">
            <a href="#" class="nav-link" v-on:click.stop.prevent="acessarFinanceiro">
              <i class="nav-icon fas fa-money-bill-alt"></i>
              <p>
                Fluxo de Caixa
              </p>
              <b-spinner v-if="flags.autenticacao.financeiro" class="ml-2" small variant="danger"></b-spinner>
            </a>
          </li>
          <li v-if="temAcessoAosRelatorios && opcaoMenuSistemaJuridico" class="nav-item">
            <a href="#" class="nav-link" v-on:click.stop.prevent="acessarRelatorios">
              <i class="nav-icon fas fa-file-alt"></i>
              <p>
                Relatórios
              </p>
              <b-spinner v-if="flags.autenticacao.relatorios" class="ml-2" small variant="danger"></b-spinner>
            </a>
          </li>
          <li v-if="opcaoMenuSistemaJuridico && !ocultarOpcaoMenuBanco" class="nav-item">
            <a href="#" class="nav-link" v-on:click.stop.prevent="acessarPreambuloBank">
              <i class="nav-icon fas fa fa-university"></i>
              <p>
                Preâmbulo Bank
              </p>
            </a>
          </li>
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <router-link class="nav-link" to="/agenda">
              <i class="nav-icon fas fa-calendar"></i>
              <p>
                Agenda
              </p>
            </router-link>
          </li>
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <router-link class="nav-link" to="/documentos">
              <i class="nav-icon fas fa-book"></i>
              <p>
                Documentos
              </p>
            </router-link>
          </li>
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <router-link class="nav-link" to="/galeria-fotos">
              <i class="nav-icon far fa-image"></i>
              <p>
                Galeria de fotos
              </p>
            </router-link>
          </li>
          <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
            <router-link class="nav-link" to="/noticias">
              <i class="nav-icon fas fa-newspaper"></i>
              <p>
                Notícias
              </p>
            </router-link>
          </li>
          <li v-if="temPermissaoMenuAdministracao" class="tituloMenuHierarquico nav-header">&nbsp;</li>
          <li v-if="temPermissaoMenuAdministracao" class="nav-item">
            <a href="#" @click.prevent="abrirTreeView" class="nav-link">
              <i class="fas fa-users-cog mr-2"></i>
              <p>Administração
                <i id="iconeSetaMenuAdministracao" class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul id="menuAdministracao" class="nav nav-treeview">
              <li v-if="temPermissaoEscritorio" class="nav-item">
                <router-link class="nav-link" to="/escritorios">
                  <i class="fa fa-building ml-2 mr-2"></i>
                  <p>Escritórios</p>
                </router-link>
              </li>
              <li v-if="usuarioLogadoEhAdministrador" class="nav-item">
                <router-link class="nav-link" to="/emitentes">
                  <i class="fas fa-file-invoice ml-2 mr-2"></i>
                  <p>Emitentes</p>
                </router-link>
              </li>
              <li v-if="usuarioLogadoEhAdministrador" class="nav-item">
                <router-link class="nav-link" to="/usuarios">
                  <i class="fas fa-users ml-2 mr-2"></i>
                  <p>Usuários</p>
                </router-link>
              </li>
              <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
                <router-link class="nav-link" to="/administracao-documentos">
                  <i class="fas fa-book ml-2 mr-2"></i>
                  <p>
                    Documentos
                  </p>
                </router-link>
              </li>
              <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
                <router-link class="nav-link" to="/administracao-galeria-fotos">
                  <i class="far fa-image ml-2 mr-2"></i>
                  <p>Galeria de fotos</p>
                </router-link>
              </li>
              <li v-if="opcaoMenuSistemaJuridico" class="nav-item">
                <router-link class="nav-link" to="/administracao-noticias">
                  <i class="fas fa-newspaper ml-2 mr-2"></i>
                  <p>
                    Notícias
                  </p>
                </router-link>
              </li>
              <li v-if="usuarioLogadoEhAdministrador && opcaoMenuSistemaJuridico" class="nav-item">
                <router-link class="nav-link" to="/politica-seguranca">
                  <i class="fas fa-lock ml-2 mr-2"></i>
                  <p>Política de Senhas</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="opcaoMenuGestaoConta  && !temPagamentoPendente" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/recursos-disponiveis">
              <i class="fas fa-cogs ml-1 mr-2"></i>
              <p class="ml-2">Recursos Disponíveis</p>
            </router-link>
          </li>
          <li v-if="opcaoMenuGestaoConta  && !temPagamentoPendente" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/mercado">
              <i class="fa fa-shopping-basket ml-1 mr-2"></i>
              <p class="ml-1">Mercado</p>
            </router-link>
          </li>
          <li v-if="opcaoMenuGestaoConta" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/pedidos">
              <i class="nav-icon fas fa-shopping-bag  mr-2"></i>
              <p>Pedidos</p>
            </router-link>
          </li>
          <li v-if="opcaoMenuGestaoConta" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/faturas">
              <i class="nav-icon fas fa-file-invoice-dollar mr-2"></i>
              <p>Faturas</p>
            </router-link>
          </li>
           <li v-if="opcaoMenuGestaoConta  && !temPagamentoPendente" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/formas-pagamento">
              <i class="fas fa-credit-card ml-1 mr-2"></i>
              <p class="ml-1">Formas de Pagamento</p>
            </router-link>
          </li>
          <!-- <li v-if="opcaoMenuGestaoConta" class="nav-item">
            <router-link active-class="linkOpcaoMenuMirtSelecionada" exact class="linkOpcaoMenuMirt nav-link" to="/consumo">
              <i class="fas fa fa-history ml-1 mr-2" aria-hidden="true"></i>
              <p class="ml-1">Consumo</p>
            </router-link>
          </li> -->
          <li v-if="opcaoMenuGestaoConta  && !temPagamentoPendente" class="nav-item">
            <a href="#" :class="{'linkOpcaoMenuMirtSelecionada': estaNaRotaEdicaoEscritorio === true}" class="linkOpcaoMenuMirt nav-link" v-on:click.stop.prevent="enviarParaEscritorio">
              <i class="nav-icon fas fa-home mr-2"></i>
              <p>Escritório</p>
            </a>
          </li>
          <li v-if="opcaoMenuGestaoConta && !temPagamentoPendente" class="nav-item">
            <a href="#" class="linkOpcaoMenuMirt nav-link" v-on:click.stop.prevent="enviarParaMirt">
              <i class="nav-icon fa fa-gavel mr-2"></i>
              <p>Jurídico</p>
              <b-spinner v-if="flags.autenticacao.mirt" class="ml-2" small variant="danger"></b-spinner>
            </a>
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import { infraMixin } from '@/modules/infra/mixins'
import constants from '@/util/constants.js'
import { BSpinner } from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'
import util from '@/util'
import mensagens from '@/util/mensagens'

export default {
  name: 'MenuLateral',
  components: {
    'b-spinner': BSpinner
  },
  mixins: [infraMixin],
  computed: {
    ...mapState('auth', ['logoCliente', 'tipoDeAcesso', 'temAcessoAoFinanceiro', 'temAcessoAosRelatorios', 'temAcessoAoFaturamento', 'temAcessoAoEscritorio', 'regrasLogin', 'nomeEmpresa', 'cpfCnpj']),
    ...mapGetters('auth', ['opcaoMenuSistemaJuridico', 'opcaoMenuGestaoConta', 'ocultarOpcaoMenuBanco']),
    temPagamentoPendente () {
      if (util.valorVazio(this.regrasLogin)) {
        return false
      }
      const pendenciasDeLogin = JSON.parse(this.regrasLogin)
      if (util.valorVazio(pendenciasDeLogin.pagamentoPendente)) {
        return false
      }
      return pendenciasDeLogin.pagamentoPendente
    },
    estaNaRotaEdicaoEscritorio () {
      const rotaAtual = this.$router.app._route.name
      if (rotaAtual === constants.nomeRotaEdicaoEscritorio) {
        return true
      }
      return false
    },
    cssClassMainSideBar () {
      if (this.opcaoMenuGestaoConta) {
        return 'main-sidebar sidebar-dark-primary elevation-0 mainSideBarGestaoConta'
      }
      return 'main-sidebar sidebar-dark-primary elevation-0'
    },
    temPermissaoMenuAdministracao () {
      if (!this.opcaoMenuSistemaJuridico) {
        return false
      }
      return (this.tipoDeAcesso === constants.tipoDeAcessoDoUsuario.administrador || this.tipoDeAcesso === constants.tipoDeAcessoDoUsuario.gestorDeConteudo)
    },
    usuarioLogadoEhAdministrador () {
      if (!this.opcaoMenuSistemaJuridico) {
        return false
      }
      return (this.tipoDeAcesso === constants.tipoDeAcessoDoUsuario.administrador)
    },
    temPermissaoEscritorio () {
      return this.temAcessoAoEscritorio && this.opcaoMenuSistemaJuridico
    },
    obterLogo () {
      return this.logoCliente
    }
  },
  data: () => {
    return {
      menuAdministracaoAberto: false,
      flags: {
        autenticacao: {
          financeiro: false,
          faturamento: false,
          relatorios: false,
          office: false,
          mirt: false
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    async enviarParaEscritorio () {
      const rotaAtual = window._Vue.$router.app._route.name
      if (rotaAtual === 'edicao-escritorio-usuario') {
        return
      }
      try {
        this.$router.push({ name: 'edicao-escritorio-usuario' })
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },
    async acessarFinanceiro () {
      this.acessarSistemaExterno(constants.urlSistemaExterno.financeiro, 'financeiro')
    },

    async acessarFaturamento () {
      this.acessarSistemaExterno(constants.urlSistemaExterno.faturamento, 'faturamento')
    },

    async acessarRelatorios () {
      this.acessarSistemaExterno(constants.urlSistemaExterno.relatorios, 'relatorios')
    },

    async acessarJudiceOffice () {
      this.acessarSistemaExterno(constants.urlSistemaExterno.juridico, 'office')
    },

    async acessarPreambuloBank () {
      window.open(constants.urlSistemaExterno.bank, '_blank')
    },

    async acessarSistemaExterno (urlSistema, flagAutenticacaoSistema, abrirEmNovaJanela = true) {
      if (!this.flags.autenticacao[flagAutenticacaoSistema]) {
        this.flags.autenticacao[flagAutenticacaoSistema] = true
        await this.redirecionarParaSistemaExterno(urlSistema, abrirEmNovaJanela)
        this.flags.autenticacao[flagAutenticacaoSistema] = false
      }
    },
    async enviarParaMirt () {
      this.acessarSistemaExterno(constants.urlSistemaExterno.mirt, 'mirt', false)
    },

    abrirTreeView () {
      if (this.menuAdministracaoAberto === true) {
        window.$('#menuAdministracao').hide()
        window.$('#iconeSetaMenuAdministracao').removeClass('fa-angle-down').addClass('fa-angle-left')
        this.menuAdministracaoAberto = false
      } else {
        window.$('#menuAdministracao').show()
        window.$('#iconeSetaMenuAdministracao').removeClass('fa-angle-left').addClass('fa-angle-down')
        this.menuAdministracaoAberto = true
      }
    },

    obterCpfCnpj () {
      return util.formatarCpfCnpj(this.cpfCnpj)
    }
  }
}
</script>

<style scoped>
@import "./scss/MenuLateral.scss";
</style>
